"use strict";

class SalesApplicationAddSaleAgentSelectionController {

  constructor($scope, $parse, $window, $timeout, $localStorage, SSConfigService, SSEoiService, SSHttpService, SSUtilService, SSAppService, SSUserService, SSAlertService, SSDateService) {
    const self = this;

    self.$scope = $scope;
    self.$parse = $parse;
    self.$window = $window;
    self.$timeout = $timeout;
    self.$storage = $localStorage;

    self.SSHttpService = SSHttpService;
    self.SSUtilService = SSUtilService;
    self.SSAppService = SSAppService;
    self.SSEoiService = SSEoiService;
    self.SSUserService = SSUserService;
    self.SSAlertService = SSAlertService;
    self.SSConfigService = SSConfigService;
    self.SSDateService = SSDateService;

    // Broker roles in a sale
    self.BROKER_ROLE_MAIN_BROKER = SHOWSUITE.BROKER_ROLE_MAIN_BROKER;  // 1
    self.BROKER_ROLE_CO_BROKER = SHOWSUITE.BROKER_ROLE_CO_BROKER;  // 2
    self.BROKER_ROLE_TAGGER = SHOWSUITE.BROKER_ROLE_TAGGER;  // 3

    /**
     * Eoi status
     */
    // EOI_STATUS_DRAFT = 10;
    // EOI_STATUS_SUCCESSFUL = 70;

    self.EOI_STATUS_DRAFT = SHOWSUITE.EOI_STATUS_DRAFT;
    self.EOI_STATUS_SUBMITTED = SHOWSUITE.EOI_STATUS_SUBMITTED;
    self.EOI_STATUS_SUCCESSFUL = SHOWSUITE.EOI_STATUS_SUCCESSFUL;

    self.BUYER_TYPE_INDIVIDUAL = SHOWSUITE.BUYER_TYPE_INDIVIDUAL;

    self.nationalities = self.SSConfigService.getNationalities();

    self.data = SHOWSUITE.data;
    self.eoiId = SHOWSUITE.data.eoi_id;
    self.launch_id = SHOWSUITE.data.launch_id;
    self.add_buyer = SHOWSUITE.data.add_buyer;

    self.PROJECT_BROKER_TYPES = {
      UNASSIGNED: 0,
      TEAMLEAD: 1,
      ASSISTANT_TEAMLEAD: 2,
      BROKER: 3,
      TAGGER: 4,
    };

      self.PROJECT_BROKER_TYPES_SELECT= null;

    self.init();
  }

  init() {
    const self = this;

    self.hasCoBroke = null;
    self.SSEoiService.hasCoBroke = 1;
    self.agents = [];
    self.prepareRoles();
    self.searched = false;

    self.$timeout(function() { 
      self.maskPhoneNumber(self, 'brokerCtrl.', 'agentSelectionDiv');
      self.maskModalPhoneNumber(self, 'brokerCtrl.', 'registerCreateAgentModal');
    });
  }

  prepareRoles() {
      const self = this;

      self.PROJECT_BROKER_TYPES_SELECT = [
          {
              'id': 1,
              'name': 'TEAMLEAD'
          }
          ,
          {
              'id': 2,
              'name': 'ASSISTANT TEAMLEAD'
          }
          ,
          {
              'id': 3,
              'name': 'BROKER'
          }
          ,
          {
              'id': 4,
              'name': 'TAGGER'
          }
      ];
  }

  searchAgent() {
    const self = this;

    self.agents = [];
    let url = 'brokers/search';
    let params = {
        criteria: self.criteria,
        agency_id: self.SSEoiService.sale_obj.agency_id
    };

    loading(true);
    self.SSHttpService.getAPIRequest(url, params).then(function (response) {
      loading(false);

      if (response instanceof Error) {
        self.SSAlertService.parseAndDisplayError(response);
        return;
      }

      if (response.data && response.data.agents) {
        self.agents = response.data.agents;

        $.each(self.agents, function (index, agent) {
          if (self.SSEoiService.brokers_obj.find(x => x.user_id == agent.user_id)) {
              agent["unselected"] = false;
          } else {
              agent["unselected"] = true;    
          }
        })
      }

      self.searched = true;
    });
  }

  resetAgencyBrokers() {
    const self = this;

    self.agents = [];
    self.criteria = "";
    self.searched = false;
  }

  addSelectedAgent(agent) {
    const self = this;

    agent["unselected"] = false;
    agent["broker_role"] = 1;

    if(self.SSEoiService.brokers_obj.length == 1){
      agent.broker_role = 2;
    }
    else if(self.SSEoiService.brokers_obj.length == 2){
      agent.broker_role = 3;
    }

    self.selectRole(agent, agent.broker_role);
    self.SSEoiService.brokers_obj.push(agent);

    self.$timeout(function() { 
      $("select.dashboard-select#broker_" + (self.SSEoiService.brokers_obj.length - 1)).niceSelect('update');
    });
  }

  selectRole(agent, old_role) {
    const self = this;
    
    if (agent.broker_role === 1) {
      let filtered_array = self.SSEoiService.brokers_obj.filter(x => x.broker_role === 1);
      if (filtered_array.length > 1) {
        agent.broker_role = old_role;
        self.SSAlertService.danger("Error!", "Only 1 buyer agent is allowed.");
        self.$timeout(function() { 
          $("select.dashboard-select").niceSelect('update');
        });
        return;
      }
    }
    
    agent["role_name"] = self.SSEoiService.broker_roles.find(x => x.id === agent.broker_role).name;
  }

  removeAgent(agent) {
    const self = this;

    if(self.SSEoiService.brokers_obj.length > 0){
      self.SSEoiService.brokers_obj.find(x => x.user_id == agent.user_id).unselected = true;
    }

    self.SSEoiService.brokers_obj = $.grep(self.SSEoiService.brokers_obj, function(e){ 
      return e.user.id != agent.user.id; 
    });

    self.$timeout(function() { 
      $("select.dashboard-select#my_broker_role").niceSelect('update');
    });
  }

  validateCoBroke() {
    const self = this;

    if (self.SSEoiService.hasCoBroke == null) {
      self.SSEoiService.coBrokeError = true;
      return false;
    }

    let co_broker_arr = [];
    //Validate role of each brokers
    for(var i = 0; i < self.SSEoiService.brokers_obj.length; i++) {
      co_broker_arr.push(self.SSEoiService.brokers_obj[i].broker_role);
    }

    let counts = {};
    co_broker_arr.forEach(function(x) { counts[x] = (counts[x] || 0)+1; });

    if (counts.hasOwnProperty("undefined")) {
      self.SSAlertService.danger('Error!', 'Please select role for each agent');
      return false;
    }

    if (counts.hasOwnProperty(1)) {
      if (counts[1] > 1) {
        self.SSAlertService.danger('Error!', 'Only 1 buyer agent is allowed');
        return false;
      }
    } else {
      if (!counts.hasOwnProperty(5) && !counts.hasOwnProperty(4)) {
        self.SSAlertService.danger('Error!', 'One of the agent must be the buyer agent or team ic or sales consultant.');
        return false;
      }
    }

    // Check for Team IC
    // if (counts.hasOwnProperty(4) && counts[4] > 1) {
    //   self.SSAlertService.danger('Error!', 'Only 1 Team IC is allowed.');
    //   return false;
    // }

    return true;
  }

  onCreateAgent() {
    const self = this;
    self.hideModals();
    let input = $('input');
    let resource_id = 'a41ce851-728e-4d65-8dc5-e0515a01ff31';

    if(self.search_type != 2 && self.criteria){
      let phoneCriteria = "";
      if(self.search_type == 3){
          phoneCriteria = self.criteria.toString().trim().replace(/\s/g, '');
          if(phoneCriteria.charAt(0) == '+'){
              phoneCriteria = phoneCriteria.replace(/^\+/, '').slice(2);
          }
      }
      loading(true);
      $.ajax({
          url: 'https://data.gov.sg/api/action/datastore_search?resource_id=' + resource_id + '&q=' + (self.search_type==3 ? phoneCriteria :  self.criteria),
          success: function (response) {
              loading(false);

              if (response && response.result && response.result.records && response.result.records.length > 0) {
                  let result = response.result.records[0];
                  let agency = self.SSEoiService.agencies.find(x => x.name == result.estate_agent_name);
                  self.registerParams = {
                      user_first_name : result.salesperson_name,
                      broker_agency_id: agency ? agency.id : 0,
                      broker_reg_no: result.registration_no
                  };

                  self.$timeout(function() { 
                      $("select.dashboard-select#register_agent_agency").niceSelect('update');
                  });

              } else {
                self.registerParams = {};
                if(self.criteria){
                  if(self.search_type == 1){
                      self.registerParams['broker_reg_no'] = self.criteria;
                  }
                  else if(self.search_type == 3){
                      self.registerParams['user_phone1'] = self.criteria;
                  }
              }
            }
              input.trigger('change');
          }, error: function (response) {
            loading(false);
            self.registerParams = {};
            // check if input is Email/CEA No/Phone No/Name and set in modal fields respectively
            if(self.criteria){
              if(self.search_type == 1){
                  self.registerParams['broker_reg_no'] = self.criteria;
              }
              else if(self.search_type == 3){
                  self.registerParams['user_phone1'] = self.criteria;
              }
          }
            input.trigger('change');
        }
      });
    }
    else {
      self.registerParams = {};
      input.trigger('change');
    }

    if(self.criteria){
      if(self.search_type == 2){
          self.registerParams['user_email'] = self.criteria;
      }
    }
    self.registerEoiAgentModal = true;
    $('#addSaleCreateAgentModal').modal('show');
    self.maskPhoneNumber(self, 'brokerCtrl.', 'frm-register-agent-dms');

  }

  maskPhoneNumber(context, contextPrefix, formId) {
    let self = this;

    if (!context) {
      return;
    }

    let parent = null;
    if (formId) {
      parent = jQuery('#' + formId);
    } else {
      parent = jQuery('body');
    }

    jQuery.each(parent.find('input[type=tel]'), function(i, el) {
      let field = jQuery(el);

      let allowDropdown = field.attr('allowDropdown');
      allowDropdown = !allowDropdown || allowDropdown !== 'false';

      field.intlTelInput({
          initialCountry: 'sg',
          geoIpLookup: self.SSUtilService.geoIpLookup,
          allowDropdown: allowDropdown,
          preferredCountries: ['sg']
      });

      let model = field.attr('ng-model');

      if (model) {
        if (startsWith(model, contextPrefix)) {
          model = model.substring(contextPrefix.length);
        }
         
        let value = self.$parse(model)(context);

        if (value) {
          field.intlTelInput('setNumber', value);
        }
      }

      field.on("keyup change", function () {
        field.parent().removeClass("has-warning");
      });
      field.blur(function () {
          
        var currentFormat = (field.val() && field.val()[0] === "+") ? intlTelInputUtils.numberFormat.INTERNATIONAL : intlTelInputUtils.numberFormat.NATIONAL;
        field.val(field.intlTelInput("getNumber", currentFormat));

        field.parent().removeClass("has-warning");
        if (!field.intlTelInput("isValidNumber")) {
          field.parent().addClass("has-warning");
          if (model) {
            //self.$parse(model).assign(context, ""); // Don't remove the number if invalid, unless we upgrade to version of latest intl-tel-input
          }
        } else {
          if (model) {
            self.$parse(model).assign(context, field.intlTelInput("getNumber"));
          }
        }
          
      });
    });
  }

  registerAgent() {
    const self = this;

    if (self.validateRegisterParams()) return;

    let params = self.registerParams;
    params["ignore_cea"] = true;

    if(self.registerParams.add_to_core_team){
      params["project_id"] = self.property.project_id;
    }
    else{
      params["project_id"] = null;
    }

    let url = 'register-broker';

    loading(true);
    self.SSHttpService.postAPIRequest(url, params).then(function (responseObj) {
        loading(false);

        if (responseObj instanceof Error) {

            self.registerError = responseObj.serverMessage;
            switch (responseObj.code) {
                case 412:
                    self.registerError = 'Incorrect Information.';
                    break;
                default:
                    self.registerError = 'Oops, Something went wrong. Please contact Showsuite support.';
                    break;
            }

            // Form Errors
            self.enquireErrors = {};
            self.registerErrors = {};

            jQuery.each(responseObj.data, function (key, value) {
                try {
                    self.enquireErrors[key] = value[0];
                } catch (ex) {
                }
                try {
                    self.registerErrors[key] = value[0];
                } catch (ex) {
                }
            });
            // Form Errors

            return;
        }

        self.hideModals();

        let agent = responseObj.data.broker;
        agent["user"] = responseObj.data.user;
        agent["agency_name"] = self.SSEoiService.agencies.find(x => x.id === agent.agency_id).name;
        
        // agent["unselected"] = false;
        // agent["broker_role"] = 0;

        // self.SSEoiService.brokers_obj.push(agent);
        // self.$timeout(function() { 
        //     $("select.dashboard-select#broker_" + (self.SSEoiService.brokers_obj.length - 1)).niceSelect('update');
        // });

        // //self.changeToDefaultScreen();
        self.addSelectedAgent(agent);
      }
    );
  }

  validateRegisterParams() {
    const self = this;

    let hasError = false;
    self.registerErrors = {};

    if (!self.registerParams.user_first_name) {
        self.registerErrors.user_first_name = "The First Name field is required.";
        hasError = true;
    }
    if (!self.registerParams.user_last_name) {
        self.registerErrors.user_last_name = "The Last Name field is required.";
        hasError = true;
    }
    if (!self.registerParams.user_email) {
        self.registerErrors.user_email = "The Email field is required.";
        hasError = true;
    }

    if (!self.registerParams.user_phone1) {
        self.registerErrors.user_phone1 = "The Phone field is required.";
        hasError = true;
    }
    //if (!self.registerParams.broker_nric) {
    //    self.registerErrors.broker_nric = "The NRIC/FIN field is required.";
    //    hasError = true;
    //} else
    if (self.registerParams.broker_nric && !validateNRIC(self.registerParams.broker_nric)) {
        self.registerErrors.broker_nric = "The NRIC/FIN format is wrong.";
        hasError = true;
    }

    if (!self.registerParams.broker_agency_id) {
        self.registerErrors.broker_agency_id = "The Agency field is required.";
        hasError = true;
    }

    // If add_to_core_team is checked then this field is required, otherwise optional
    if(self.registerParams.add_to_core_team){
      if (!self.registerParams.broker_role) {
        self.registerErrors.broker_role = "The Role field is required.";
        hasError = true;
      }
    }
    

    if (!self.registerParams.broker_reg_no) {
        self.registerErrors.broker_reg_no = "The Registration No. field is required.";
        hasError = true;
    }

    if (jQuery('.intl-tel-input').hasClass('has-error') && jQuery("[allowdropdown='']").val() != '') {
        self.registerErrors.user_phone1 = "The Phone format is not valid.";
        hasError = true;
    }

    return hasError;
  }

  hideModals() {
    const self = this;

    self.showModal = false;
    if ($('#confirmAddBuyerModal').is(':visible')) $('#confirmAddBuyerModal').modal('hide');
    if ($('#addSaleCreateAgentModal').is(':visible')) $('#addSaleCreateAgentModal').modal('hide');
  }

  displayEmailOrPhoneRequiredModal() {
    const self = this;

    self.closeModal();

    self.email_phone_modal = true;
    $('#email_phone_modal').modal('show');
  }

  closeModal() {
    const self = this;

    self.email_phone_modal = false;

    if ($('#email_phone_modal').is(':visible')) $('#email_phone_modal').modal('hide');
  }

  onBookingProceed() {
    const self = this;

    let url = 'sec/developer/sales';
    let params = {
      unit_id: self.SSEoiService.sale_obj.selected_units[0].id,
      agency_id: self.SSEoiService.sale_obj.agency_id,
      otp_no: self.SSEoiService.sale_obj.otp_no,
      otp_date: self.SSDateService.formateWithTimeAsNoon(self.SSEoiService.sale_obj.otp_date),
    };

    if (self.SSEoiService.brokers_obj.length > 0) {
      params["brokers"] = self.prepareBrokerId();
    }

    loading(true);
    if (self.SSEoiService.sale_obj.id) {
      url = 'sec/developer/sales/' + self.SSEoiService.sale_obj.id;
      self.SSHttpService.putAPIRequest(url, params).then(function (response) {
        loading(false);
        if (response instanceof Error) {
          self.SSAlertService.parseAndDisplayError(response);
          return;
        }

        self.SSEoiService.sale_obj.price = response.data.sales[0].price;
        self.SSEoiService.sale_obj["id"] = response.data.sales[0].id;

        self.SSEoiService.currentPage = self.SSEoiService.LAUNCH_BUYER_PARTICULAR_PAGE;
        self.$scope.$parent.ctrl.pingSaleStatus();
      });
    } else {
      self.SSHttpService.postAPIRequest(url, params).then(function (response) {
        loading(false);
        if (response instanceof Error) {
          self.SSAlertService.parseAndDisplayError(response);
          return;
        }

        self.SSEoiService.sale_obj.price = response.data.sales[0].price;
        self.SSEoiService.sale_obj["id"] = response.data.sales[0].id;

        self.SSEoiService.currentPage = self.SSEoiService.LAUNCH_BUYER_PARTICULAR_PAGE;
        self.SSAlertService.message = null;
        self.$scope.$parent.ctrl.pingSaleStatus();
      });
    }    
  }

  prepareBrokerId() {
    const self = this;

    let broker_arr = [];
    let broker = [];

    for (var i = 0; i < self.SSEoiService.brokers_obj.length; i++) {
      broker = [];
      broker.push(self.SSEoiService.brokers_obj[i].user.id);
      broker.push(self.SSEoiService.brokers_obj[i].broker_role);
      broker_arr.push(broker);
    }

    return JSON.stringify(broker_arr);
  }

  maskPhoneNumber(context, contextPrefix, formId) {
        let self = this;

        if (!context) {
            return;
        }

        let parent = null;
        if (formId) {
            parent = jQuery('#' + formId);
        } else {
            parent = jQuery('body');
        }

        jQuery.each(parent.find('input[type=tel]'), function (i, el) {
            let field = jQuery(el);

            let allowDropdown = field.attr('allowDropdown');
            allowDropdown = !allowDropdown || allowDropdown !== 'false';

            field.intlTelInput({
                initialCountry: 'sg',
                geoIpLookup: self.SSUtilService.geoIpLookup,
                allowDropdown: allowDropdown,
                preferredCountries: ['sg']
            });

            let model = field.attr('ng-model');
            if (model) {
                if (startsWith(model, contextPrefix)) {
                    model = model.substring(contextPrefix.length);
                }
                let value = self.$parse(model)(context);
                if (value) {
                    field.intlTelInput('setNumber', value);
                }
            }


            field.on("keyup change", function () {
                field.parent().removeClass("has-error");
            });
            field.blur(function () {
                var currentFormat = (field.val() && field.val()[0] === "+") ? intlTelInputUtils.numberFormat.INTERNATIONAL : intlTelInputUtils.numberFormat.NATIONAL;
                field.val(field.intlTelInput("getNumber", currentFormat));

                field.parent().removeClass("has-error");
                if (!field.intlTelInput("isValidNumber")) {
                    field.parent().addClass("has-error");
                    if (model) {
                        //self.$parse(model).assign(context, ""); // Don't remove the number if invalid, unless we upgrade to version of latest intl-tel-input
                        //Display error
                        let input = $('input');
                        input.trigger('change');
                        self.input_error = "Invalid Contact No. Please enter the correct contact no.";
                    }
                } else {
                    //Remove error
                    let input = $('input');
                    input.trigger('change');
                    self.input_error = "";

                    if (model) {
                        self.$parse(model).assign(context, field.intlTelInput("getNumber"));
                    }
                }
            });
        });
    }
    
    maskModalPhoneNumber(context, contextPrefix, formId) {
        let self = this;

        if (!context) {
            return;
        }

        let parent = null;
        if (formId) {
            parent = jQuery('#' + formId);
        } else {
            parent = jQuery('body');
        }

        jQuery.each(parent.find('input[type=tel]'), function (i, el) {
            let field = jQuery(el);

            let allowDropdown = field.attr('allowDropdown');
            allowDropdown = !allowDropdown || allowDropdown !== 'false';

            field.intlTelInput({
                initialCountry: 'sg',
                geoIpLookup: self.SSUtilService.geoIpLookup,
                allowDropdown: allowDropdown,
                preferredCountries: ['sg']
            });

            let model = field.attr('ng-model');
            if (model) {
                if (startsWith(model, contextPrefix)) {
                    model = model.substring(contextPrefix.length);
                }
                let value = self.$parse(model)(context);
                if (value) {
                    field.intlTelInput('setNumber', value);
                }
            }


            field.on("keyup change", function () {
                field.parent().removeClass("has-error");
            });
            field.blur(function () {
                var currentFormat = (field.val() && field.val()[0] === "+") ? intlTelInputUtils.numberFormat.INTERNATIONAL : intlTelInputUtils.numberFormat.NATIONAL;
                field.val(field.intlTelInput("getNumber", currentFormat));

                field.parent().removeClass("has-error");
                if (!field.intlTelInput("isValidNumber")) {
                    field.parent().addClass("has-error");
                    if (model) {
                        //self.$parse(model).assign(context, ""); // Don't remove the number if invalid, unless we upgrade to version of latest intl-tel-input
                        //Display error
                        let input = $('input');
                        input.trigger('change');
                        if (!self.registerErrors) {
                            self.registerErrors = {};
                        }
                        self.registerErrors.user_phone1 = "Invalid Contact No. Please enter the correct contact no.";
                    }
                } else {
                    //Remove error
                    let input = $('input');
                    input.trigger('change');
                    if (!self.registerErrors) {
                        self.registerErrors = {};
                    }
                    self.registerErrors.user_phone1 = "";

                    if (model) {
                        self.$parse(model).assign(context, field.intlTelInput("getNumber"));
                    }
                }
            });
        });
    }

}

SalesApplicationAddSaleAgentSelectionController.$inject = ['$scope', '$parse', '$window', '$timeout', '$localStorage', 'SSConfigService', 'SSEoiService', 'SSHttpService', 'SSUtilService', 'SSAppService', 'SSUserService', 'SSAlertService', 'SSDateService'];
app.controller('SalesApplicationAddSaleAgentSelectionController', SalesApplicationAddSaleAgentSelectionController);